import certificateMemoryCache from './certificateMemoryCache';

/**
 * Get private key for current store and environment
 * Uses proactive memory cache - automatically reloads if mismatch detected via localStorage
 */
export async function getPrivateKey(storeId: string, env: string): Promise<string> {
  // The cache now handles sync checks and loading internally before every access
  const privateKey = await certificateMemoryCache.getPrivateKey(storeId, env);

  if (!privateKey) {
    console.error(`[getPrivateKey] ❌ Private key not available for ${storeId}/${env} even after proactive load!`);
    throw new Error(`Private key not available for ${storeId}/${env}`);
  }

  return privateKey;
}
